(function () {
  'use strict';

  var DD_PROFILE_COPY={"tr":{"more":"Devamını Oku","less":"Daha Az Göster","following":"Tasarımcı takip ediliyor.","unfollowed":"Tasarımcı takibi bırakıldı."},"en":{"more":"Read more","less":"Show less","following":"You are now following this designer.","unfollowed":"You are no longer following this designer."},"es":{"more":"Leer más","less":"Mostrar menos","following":"Ahora sigues a este diseñador.","unfollowed":"Has dejado de seguir a este diseñador."},"ru":{"more":"Читать далее","less":"Показать меньше","following":"Вы подписались на дизайнера.","unfollowed":"Вы отписались от дизайнера."},"ar":{"more":"قراءة المزيد","less":"عرض أقل","following":"أنت تتابع هذا المصمم الآن.","unfollowed":"تم إلغاء متابعة هذا المصمم."},"de":{"more":"Weiterlesen","less":"Weniger anzeigen","following":"Du folgst diesem Designer jetzt.","unfollowed":"Du folgst diesem Designer nicht mehr."},"fr":{"more":"Lire la suite","less":"Afficher moins","following":"Vous suivez désormais ce designer.","unfollowed":"Vous ne suivez plus ce designer."}};
  function ddProfileCopy(){return DD_PROFILE_COPY[String(document.documentElement.lang||"tr").toLowerCase().split("-")[0]]||DD_PROFILE_COPY.tr;}

  var PANEL_ORIGINS = new Set(['https://draganddrop.online', 'https://www.draganddrop.online']);
  var MESSAGE_SOURCE = 'draganddrop-customer-action';

  function normalize(value) {
    return String(value || '').toLocaleLowerCase('tr-TR').trim();
  }

  function storageKey(slug) {
    return 'dd:follow:' + (slug || 'designer');
  }

  function cachedFollow(slug) {
    try { return window.localStorage.getItem(storageKey(slug)) === '1'; }
    catch (_error) { return false; }
  }

  function setCachedFollow(slug, active) {
    try { window.localStorage.setItem(storageKey(slug), active ? '1' : '0'); }
    catch (_error) {}
  }

  function setFollowState(link, active) {
    if (!link) return;
    link.setAttribute('aria-pressed', active ? 'true' : 'false');
    link.dataset.active = active ? 'true' : 'false';
    var label = link.querySelector('[data-dd-follow-label]');
    if (label) label.textContent = active ? 'Takip Ediliyor' : 'Takip Et';
  }

  function showToast(root, message) {
    var toast = root.querySelector('[data-dd-designer-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(Number(toast.dataset.timer || 0));
    toast.dataset.timer = String(window.setTimeout(function () { toast.classList.remove('is-visible'); }, 3000));
  }

  function queryValues(searchParams, name) {
    var values = [];
    searchParams.getAll(name).forEach(function (value) {
      String(value || '').split(',').forEach(function (part) {
        var normalized = String(part || '').trim();
        if (normalized && values.indexOf(normalized) === -1) values.push(normalized);
      });
    });
    return values;
  }

  function updateFilterSummary(root) {
    var form = root.querySelector('[data-dd-filter-form]');
    if (!form) return;

    var active = 0;
    form.querySelectorAll('[data-dd-filter-input]').forEach(function (input) {
      if (input.type === 'checkbox' ? input.checked : String(input.value || '').trim() !== '') active += 1;
    });

    var summary = root.querySelector('[data-dd-filter-count]');
    if (summary) summary.textContent = active ? ' (' + active + ')' : '';

    var result = root.querySelector('[data-dd-filter-results]');
    if (result) {
      var visible = root.querySelectorAll('[data-dd-designer-card]:not([hidden])').length;
      result.textContent = active ? active + ' filtre seçili · ' + visible + ' ürün' : visible + ' ürün';
    }
  }

  function syncFilterForm(root) {
    var form = root.querySelector('[data-dd-filter-form]');
    if (!form) return;

    var searchParams = new URL(window.location.href).searchParams;
    form.querySelectorAll('[data-dd-filter-input]').forEach(function (input) {
      var values = queryValues(searchParams, input.name);
      if (input.type === 'checkbox') {
        input.checked = values.indexOf(String(input.value)) !== -1;
      } else if (values.length) {
        input.value = values[0];
      }
    });
    updateFilterSummary(root);
  }

  function preserveFiltersOnSort(root, form) {
    form.querySelectorAll('[data-dd-sort-persist]').forEach(function (input) { input.remove(); });
    root.querySelectorAll('[data-dd-filter-input]').forEach(function (input) {
      var active = input.type === 'checkbox' ? input.checked : String(input.value || '').trim() !== '';
      if (!active || !input.name) return;
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = input.name;
      hidden.value = input.value;
      hidden.dataset.ddSortPersist = 'true';
      form.appendChild(hidden);
    });
  }

  function applyProfileFilters(root) {
    var query = normalize(root.querySelector('[data-dd-designer-search]')?.value);
    var sale = root.querySelector('[data-dd-local-filter="sale"]')?.getAttribute('aria-pressed') === 'true';
    var sameDay = root.querySelector('[data-dd-local-filter="same-day"]')?.getAttribute('aria-pressed') === 'true';
    var visible = 0;

    root.querySelectorAll('[data-dd-designer-card]').forEach(function (card) {
      var matches = (!query || normalize(card.dataset.title).includes(query)) &&
        (!sale || card.dataset.sale === 'true') &&
        (!sameDay || card.dataset.sameDay === 'true');
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    var empty = root.querySelector('[data-dd-designer-empty]');
    if (empty) empty.hidden = visible !== 0;
    updateFilterSummary(root);
  }

  function initReelsCarousel(root) {
    var viewport = root.querySelector('[data-dd-reels-viewport]');
    var track = root.querySelector('[data-dd-reels-track]');
    var previous = root.querySelector('[data-dd-reels-prev]');
    var next = root.querySelector('[data-dd-reels-next]');
    if (!viewport || !track || !previous || !next) return;

    function updateControls() {
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      previous.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll - 2;
    }

    function scrollByCard(direction) {
      var item = track.querySelector('.dddp-reels__item');
      var amount = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || '0') : viewport.clientWidth;
      viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });
    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function initProfile(root) {
    if (!root || root.dataset.ddProfileReady === 'true') return;
    root.dataset.ddProfileReady = 'true';

    var readMore = root.querySelector('[data-dd-designer-read-more]');
    var bio = root.querySelector('[data-dd-designer-bio]');
    readMore?.addEventListener('click', function () {
      var expanded = readMore.getAttribute('aria-expanded') === 'true';
      readMore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      readMore.textContent = expanded ? ddProfileCopy().more : ddProfileCopy().less;
      bio?.classList.toggle('is-expanded', !expanded);
    });

    root.querySelector('[data-dd-designer-search]')?.addEventListener('input', function () { applyProfileFilters(root); });
    syncFilterForm(root);
    root.querySelector('[data-dd-filter-form]')?.addEventListener('input', function () { updateFilterSummary(root); });
    root.querySelector('[data-dd-filter-form]')?.addEventListener('change', function () { updateFilterSummary(root); });
    root.querySelector('[data-dd-filter-form]')?.addEventListener('submit', function (event) {
      event.currentTarget.querySelectorAll('[data-dd-filter-input]').forEach(function (input) {
        if (input.type !== 'checkbox' && String(input.value || '').trim() === '') input.disabled = true;
      });
    });
    var sortForm = root.querySelector('[data-dd-sort-form]');
    sortForm?.addEventListener('submit', function (event) {
      preserveFiltersOnSort(root, event.currentTarget);
    });
    sortForm?.querySelector('select')?.addEventListener('change', function () {
      sortForm.requestSubmit();
    });
    root.querySelectorAll('[data-dd-local-filter]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        var active = button.getAttribute('aria-pressed') === 'true';
        var serverFilter = button.getAttribute('data-dd-server-filter');
        if (serverFilter) {
          event.preventDefault();
          window.location.assign(active ? button.getAttribute('data-dd-server-clear') : serverFilter);
          return;
        }
        button.setAttribute('aria-pressed', active ? 'false' : 'true');
        applyProfileFilters(root);
      });
    });
    initReelsCarousel(root);

    var follow = root.querySelector('[data-dd-designer-follow]');
    if (follow) {
      var slug = follow.dataset.designerSlug || root.dataset.designerSlug || '';
      setFollowState(follow, cachedFollow(slug));
      follow.addEventListener('click', function (event) {
        event.preventDefault();
        var active = follow.dataset.active === 'true';
        var url;
        try { url = new URL(follow.dataset.actionUrl || follow.href); }
        catch (_error) { window.location.assign(follow.href); return; }

        url.searchParams.set('action', 'follow');
        url.searchParams.set('desired_active', active ? '0' : '1');
        url.searchParams.set('return_to', window.location.href);
        url.searchParams.set('vendor_profile_id', '');
        url.searchParams.set('designer_slug', slug);
        url.searchParams.set('designer_name', follow.dataset.designerName || '');
        url.searchParams.set('designer_url', follow.dataset.designerUrl || window.location.href);
        url.searchParams.set('source_shopify_product_id', '');

        follow.setAttribute('aria-busy', 'true');
        var popup = window.open(url.toString(), 'dd-designer-follow-' + slug.replace(/[^a-z0-9]/gi, '-'), 'popup=yes,width=540,height=720,resizable=yes,scrollbars=yes');
        if (!popup) { window.location.assign(url.toString()); return; }
        popup.focus();
        var watcher = window.setInterval(function () {
          if (!popup.closed) return;
          window.clearInterval(watcher);
          follow.removeAttribute('aria-busy');
        }, 400);
      });
    }
  }

  function applyDirectory(root) {
    var query = normalize(root.querySelector('[data-dd-directory-search]')?.value);
    var productsOnly = root.querySelector('[data-dd-directory-filter="products"]')?.getAttribute('aria-pressed') === 'true';
    var collabOnly = root.querySelector('[data-dd-directory-filter="collab"]')?.getAttribute('aria-pressed') === 'true';
    var sort = root.querySelector('[data-dd-directory-sort]')?.value || 'featured';
    var grid = root.querySelector('[data-dd-directory-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-dd-directory-card]'));
    var visible = 0;

    cards.forEach(function (card) {
      var matches = (!query || normalize(card.dataset.title).includes(query)) &&
        (!productsOnly || Number(card.dataset.products || 0) > 0) &&
        (!collabOnly || card.dataset.collab === 'true');
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    if (sort !== 'featured') {
      cards.sort(function (a, b) {
        if (sort === 'products') return Number(b.dataset.products || 0) - Number(a.dataset.products || 0);
        return String(a.dataset.title || '').localeCompare(String(b.dataset.title || ''), document.documentElement.lang || 'tr');
      }).forEach(function (card) { grid.appendChild(card); });
    }

    var empty = root.querySelector('[data-dd-directory-empty]');
    if (empty) empty.hidden = visible !== 0;
  }

  function initDirectory(root) {
    if (!root || root.dataset.ddDirectoryReady === 'true') return;
    root.dataset.ddDirectoryReady = 'true';
    root.querySelector('[data-dd-directory-search]')?.addEventListener('input', function () { applyDirectory(root); });
    root.querySelector('[data-dd-directory-sort]')?.addEventListener('change', function () { applyDirectory(root); });
    root.querySelectorAll('[data-dd-directory-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        applyDirectory(root);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-dd-designer-profile]').forEach(initProfile);
    document.querySelectorAll('[data-dd-designer-directory]').forEach(initDirectory);
  }

  window.addEventListener('message', function (event) {
    if (!PANEL_ORIGINS.has(event.origin) || event.data?.source !== MESSAGE_SOURCE || event.data.action !== 'follow') return;
    document.querySelectorAll('[data-dd-designer-profile]').forEach(function (root) {
      var follow = root.querySelector('[data-dd-designer-follow]');
      if (!follow) return;
      var slug = follow.dataset.designerSlug || root.dataset.designerSlug || '';
      if (event.data.identifier && slug && String(event.data.identifier) !== slug) return;
      var active = Boolean(event.data.active);
      setCachedFollow(slug, active);
      setFollowState(follow, active);
      follow.removeAttribute('aria-busy');
      showToast(root, active ? ddProfileCopy().following : ddProfileCopy().unfollowed);
    });
  });

  document.addEventListener('dd:products:appended', function (event) {
    var scope = event.target && event.target.closest ? event.target.closest('[data-dd-designer-profile]') : null;
    if (scope) applyProfileFilters(scope);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

